import { render, staticRenderFns } from "./AccountSection.vue?vue&type=template&id=e848da20&scoped=true&"
import script from "./AccountSection.vue?vue&type=script&lang=js&"
export * from "./AccountSection.vue?vue&type=script&lang=js&"
import style0 from "./AccountSection.vue?vue&type=style&index=0&id=e848da20&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e848da20",
  null
  
)

export default component.exports